import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IframeComm from 'react-iframe-comm';

class CtAdminApi extends Component {
  constructor(props) {
    super(props);
  }

  handleOnReady = () => {
    console.log('IframeComm API Ready');
  };

  render() {
    const { handleOnReady } = this;

    const { frameWidth, frameHeight, frameBorder } = this.props;
    const attributes = {
      src: '/api/docs',
      width: frameWidth,
      height: frameHeight,
      frameBorder: frameBorder
    };

    return <IframeComm attributes={attributes} handleReady={handleOnReady} />;
  }
}

CtAdminApi.propTypes = {};
CtAdminApi.defaultProps = {
  frameWidth: '100%',
  frameHeight: '100%',
  frameBorder: 0
};

export default CtAdminApi;



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminApi.js